import { LOCALHOST_ENVIRONMENT } from "common/environment";
import {
	BMS_ORG_ID,
	BMS_TEST_ORG_ID,
} from "views/SharedScene/StreamingStatesConstants";

/**
 * The category whose objects are expected to be SGVSB-matched. Preselected for
 * the BMS org when the library opens.
 *
 * It no longer has any bearing on the SGVSB-only filter: that filter used to be
 * derived from this category, but users asked to control it themselves, so it
 * now starts off and is only ever switched by its checkbox.
 */
export const SGVSB_DEFAULT_CATEGORY = "bathroom";

/**
 * Whether the SGVSB-only filter is available to this organization at all.
 *
 * The filter is only useful for BMS — its "matched against the SGVSB database"
 * flag is meaningless for other orgs' imports — so it is restricted to the BMS
 * prod org and the internal testing org in production, and shown for every org
 * on stage and localhost.
 *
 * This gates the checkbox, and with it the filter entirely: an org that cannot
 * see the checkbox can never switch the filter on.
 */
export const canUseSgvsbFilter = (organizationId?: string): boolean => {
	const isNonProdEnvironment =
		LOCALHOST_ENVIRONMENT ||
		window?.location?.hostname?.includes("hegias-stage.com");

	return (
		Boolean(isNonProdEnvironment) ||
		organizationId === BMS_ORG_ID ||
		organizationId === BMS_TEST_ORG_ID
	);
};
